import marcadorConsumoAlimentar from '@/router/atencao-basica/marcadorConsumoAlimentar'
import parametrizacao from './parametrizacao'
import fichaComplementar from '@/router/atencao-basica/fichaComplementar'
import cadastroIndividual from './cadastroIndividual'
import cadastroDomiciliar from './cadastroDomiciliar'
import atendimentoOdontologico from './atendimentoOdontologico'
import relatorioAtendimentoOdontologico from './relatorioAtendimentoOdontologico'
import atendimentoIndividual from './atendimentoIndividual'
import atividadeColetiva from './atividadeColetiva'
import relatorioCadastroConsistente from './relatorioCadastroConsistente'
import avaliacao from './avaliacao'
import procedimento from './procedimento'
import exportacao from './exportacao'
import fichaVacinacao from './fichaVavinacao'
import visitaDomiciliar from './visitaDomiciliar'
import atendimentoDomiciliar from './atendimentoDomiciliar'
import relatorioEstatisticoAtendimento from './relatorioEstatisticoAtendimento'
import relatorioInconsistencia from './relatorioInconsistencia'

export default [
    {
        path: 'atencao-basica',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...marcadorConsumoAlimentar,
            ...parametrizacao,
            ...fichaComplementar,
            ...cadastroIndividual,
            ...cadastroDomiciliar,
            ...atendimentoOdontologico,
            ...relatorioAtendimentoOdontologico,
            ...atendimentoIndividual,
            ...atividadeColetiva,
            ...relatorioCadastroConsistente,
            ...avaliacao,
            ...procedimento,
            ...exportacao,
            ...fichaVacinacao,
            ...visitaDomiciliar,
            ...atendimentoDomiciliar,
            ...relatorioEstatisticoAtendimento,
            ...relatorioInconsistencia,
        ]
    }
]
